import { isNil, omit, omitBy } from 'lodash-unified';
import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import { debounceAsync } from '@bg-shared/utils/debounceAsync';
import { authStore } from '@bg-shared/business/Auth/Auth.store';
import { INestedKeys } from '@bg-shared/interfaces/INestedKeys';
import PlayerSettingsStore, { playerSettingsStore } from './PlayerSettings.store';
import { IPlayerSettingsModel } from './interfaces';

const omitFields: INestedKeys<IPlayerSettingsModel>[] = [
    'autoShowRouletteStatistics',
    'gui.forcedOnLowQuality',
    'rouletteNeighbourCount',
    'autoPlayTooltipSeen',
];

class PlayerSettingsApi {
    private readonly DEBOUNCE_TIME = 1000;

    private debounceUpdate = debounceAsync(
        () =>
            httpClientRepository.post(API_URLS.PLAYER_SETTINGS, {
                data: omitBy(omit(playerSettingsStore.value, omitFields), isNil),
                maxRetries: 3,
            }),
        this.DEBOUNCE_TIME,
    );

    public update(updateFn: (store: PlayerSettingsStore) => void): void {
        updateFn(playerSettingsStore);

        if (authStore.value) {
            this.debounceUpdate().catch((error) => {
                console.error(error);
            });
        }
    }
}

export const playerSettingsApi = new PlayerSettingsApi();
